import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  COMMUNITY_GROUP_NAME,
  CONTACT_EMAIL,
  INTERNAL_LIAISON,
  INTERNAL_LIAISON_EMAIL,
  REPRESENTATION_CATEGORY,
  REPRESENTATIVE_NAME,
} from 'constants/formFields';
import { DEFAULT_OPTION, OPTION_CATEGORY_COMMUNITY } from 'constants/general';
import getValueOption from 'utils/getOptionValue';
import { communitiesCreateSchema } from 'utils/validators';

import type { TCommunitiesCreateSchema } from 'utils/validators';
import type ICreateCommunitiesForm from '../interfaces/ICreateCommunitiesForm';

const useCreateCommunitiesForm = ({ isPageLoading, selectedItem }: ICreateCommunitiesForm) => {
  const {
    control,
    handleSubmit,
    formState: { isDirty, isLoading },
    reset,
    setError,
    getValues,
    watch,
    setValue,
    resetField,
  } = useForm<TCommunitiesCreateSchema>({
    mode: 'onSubmit',
    resolver: yupResolver(communitiesCreateSchema),
    defaultValues: {
      [COMMUNITY_GROUP_NAME]: '',
      [REPRESENTATION_CATEGORY]: DEFAULT_OPTION,
      [CONTACT_EMAIL]: '',
      [REPRESENTATIVE_NAME]: '',
      [INTERNAL_LIAISON]: '',
      [INTERNAL_LIAISON_EMAIL]: '',
    },
  });

  useEffect(() => {
    if (selectedItem) {
      setValue(COMMUNITY_GROUP_NAME, selectedItem.name);
      setValue(REPRESENTATION_CATEGORY, getValueOption(OPTION_CATEGORY_COMMUNITY, selectedItem.representationCategory));
      setValue(CONTACT_EMAIL, selectedItem.contactEmail);
      setValue(REPRESENTATIVE_NAME, selectedItem.contactName);
      setValue(INTERNAL_LIAISON, selectedItem.internalLiaison);
      setValue(INTERNAL_LIAISON_EMAIL, selectedItem.internalLiaisonEmail);
    }
  }, [selectedItem, setValue]);

  useEffect(() => {
    if (!isPageLoading) {
      reset();
    }
  }, [reset, isPageLoading]);

  const fieldsName = Object.keys(getValues());

  return {
    control,
    handleSubmit,
    isDirty,
    reset,
    isLoading,
    setError,
    fieldsName,
    watch,
    setValue,
    resetField,
  };
};

export default useCreateCommunitiesForm;
